module.exports = __webpack_public_path__ + "img/mantera_preview_2.bef590b5.png";